import "./App.css";
import Home from "./components/Home";
import About from "./components/About";
import Navbar from "./components/Navbar";
import FeaturesCheckbox from "./components/FeaturesCheckbox";
import Subscriptions from "./components/Subscriptions";
import { Footer, FooterDesktop } from "./components/Footer";
import Testimonials from "./components/Testimonials";
import useScreenSize from "./useScreenSize";
import {
  getScreenSize,
  setScreenSize,
  mainSectionHeight,
  getIsMobile,
  getMainSectionAfterHomeHeight,
  getIsTablet,
  // StylesDictionary,
} from "./globalConstants";
import React, { useEffect, useState } from "react";
import { Logger } from "./firebaseLogging/Logger";
import { FeedbackEngineDesktop, FeedbackEngineMobile } from "./components/FeedbackEngine";
import { DuplicatePokerDesktop, DuplicatePokerMobile } from "./components/DuplicatePoker";
import { PlayWithFriends, PlayWithFriendsDesktop } from "./components/PlayVsFriends";
import { Statistics, StatisticsDesktop } from "./components/StatisticsPage";
import { GotAQuestion, GotAQuestionDesktop } from "./components/GotAQuestion";
import { HowItWorksSection, HowItWorksSectionMobile, HowItWorksSectionTablet } from "./components/howItWorks";


let logger: Logger = null;

export function sendLog(message: string) {
  if (logger != undefined || logger != null) {
    logger.addLog(message);
  } else {
    console.error("sendLog: logger is undefined or null")
  }
}

function App() {


  const [screenSizeReady, setScreenSizeReady] = useState(false)
  const [forceRefresh, setForceRefresh] = useState(0);
  setScreenSize(useScreenSize());

  useEffect(() => {

    if (logger == null) {
      logger = new Logger()
    }
  }, []);
  if (!screenSizeReady && getScreenSize().height != -1) {
    setScreenSizeReady(true)
  }
  if (!screenSizeReady) {
    setForceRefresh((forceRefresh + 1) % 2)
    return (null)
  }

  const screenSize = getScreenSize();
  //alert(JSON.stringify(screenSize))
  const isMobile = getIsMobile();
  const isTablet: boolean = getIsTablet();
  const isMobileOrTablet: boolean = isMobile || isTablet
  const screenWidthPC = Math.round(80 + (1 - screenSize.width / 1900) * 15)
  const styles: { [key: string]: React.CSSProperties } = {
    app: {
      display: "flex",
      justifyContent: "center",
      margin: "0rem auto",
      width: "100vw",//screenSize["width"],
      overflow: "hidden"
      //  overflowX: isMobileOrTablet ? "hidden" : "visible" // Disable horizontal scrolling
    },
    mainSection: {
      //maxWidth: "1900px",
      justifyContent: "center",
      alignItems: "center",
      display: "inline-block",
      width: "100%",
      flexDirection: "column" as "column",
      // height: mainSectionHeight(),
      marginTop: getIsMobile() ? "7vh" : "10vh",
      flex: 1
    },
    mainAfterHome: {
      marginLeft: isMobileOrTablet ? "2.5%" : ((100 - screenWidthPC) / 2).toString() + "%",
      marginRight: isMobileOrTablet ? "2.5%" : ((100 - screenWidthPC) / 2).toString() + "%",
      width: isMobileOrTablet ? "95%" : screenWidthPC.toString() + "%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      flexDirection: "column",
      // height: getMainSectionAfterHomeHeight(),
      // minHeight: "9000px"
    },
  };
  return (
    <div className="App" id="top-of-page" style={styles.app}>
      <div className="main-section" style={styles.mainSection}>
        <Home />
        {getIsMobile() ? <HowItWorksSectionMobile /> : (getIsTablet() ? <HowItWorksSectionTablet /> : <HowItWorksSection />)}
        {getIsMobile() ? <DuplicatePokerMobile /> : <DuplicatePokerDesktop />}
        {getIsMobile() || (isMobileOrTablet && getScreenSize().width < getScreenSize().height) ? <FeedbackEngineMobile /> : <FeedbackEngineDesktop />}


        {/* {getIsMobile() ? <PlayWithFriends /> : <PlayWithFriendsDesktop />} */}
        {getIsMobile() || (isMobileOrTablet && getScreenSize().width < getScreenSize().height) ? <Statistics /> : <StatisticsDesktop />}
        {getIsMobile() || (isMobileOrTablet && (getScreenSize().width < getScreenSize().height || getScreenSize().height < 450)) ? <GotAQuestion /> : <GotAQuestionDesktop />}
        {getIsMobile() || (isMobileOrTablet && getScreenSize().width < getScreenSize().height) ? <Footer /> : <FooterDesktop />}

      </div>
      <Navbar />
    </div>
  );
}

export default App;
{/* <div className="main-after-home" style={styles.mainAfterHome}>
          <FeaturesCheckbox />
          <Subscriptions />
          <Testimonials />
          <About />
        </div> */}